<template>
    <div>
      <header-component active="/maternity" isCurrent="11"></header-component>
      <!-- <product-component isCurrent="6"></product-component> -->
        <div class="property-content">
            <div class="banner">
                <div class="banner_box animate-text">
                    <div class="banner_box-black">
                    <div class="banner_title banner_big_title">
                        月子服务
                    </div>
                    <div class="banner_subTitle">
                        专为现代月子中心量身打造集智能化管理、数据化运营、自动化流程于一体。深度整合客户全生命周期管理、标准化护理服务体系、精细化财务管控及智能营销分析等核心业务模块，助力企业实现服务体验升级与经营效益倍增，最终达成客户满意度提升与企业价值增长的双赢格局。
                    </div>
                    </div>
                </div>
            </div>

            <div class="product-net">
            <div class="property-net">

                <div class="property-net-list isbg" style="padding: 30px 0 30px;">
                    <div class="box-width">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="property-net-img slide-in-left" style="width: 85%;">
                                <img src="../../assets/pro/maternity_mobile.png" alt="">
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="slide-in-right">
                            <div class="title bigTop">微信客户端</div>
                            <div class="details">为月子中心客户提供便捷、贴心的移动端服务体验。客户可随时随地享受全周期数字化健康管理、实时查阅母婴健康档案、查看个性化护理方案、即时沟通诉求、营养膳食点餐、康复课程排气等，以提高客户的体验，打造差异化竞争优质</div>
                            <div class="classify">
                                <el-row :gutter="20">
                                    <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item, index) in mobileList" :key="index">
                                        <div class="classify-hover-pink">
                                            <img :src="item.icon" alt="" class="sway">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            </div>
                        </el-col>
                    </el-row> 
                    </div> 
                </div>

                <div class="property-net-list isbg2">
                    <div class="box-width">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="slide-in-left">
                            <div class="title bigTop">企业管理后台</div>
                            <div class="details">
                                通过云端数据中台实现全部门店信息的标准化整合与智能化管理。系统可灵活定制符合企业特色的标准化管理流程与业务审批体系，确保跨区域运营的规范性与一致性，实现“集团管控一张网、业务运营一盘棋”的智慧管理新范式，助力连锁品牌实现规模化扩张与精细化运营的完美平衡。
                            </div>
                            <div class="classify">
                                <el-row :gutter="20">
                                    <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item, index) in pcList" :key="index">
                                        <div class="classify-hover-pink">
                                            <img :src="item.icon" alt="" class="sway">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            </div>
                        </el-col>
                        
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="property-net-img slide-in-right" style="width: 100%;">
                                <img src="../../assets/pro/maternity-pc.png" alt="">
                            </div>
                        </el-col>
                    </el-row>
                    </div>  
                </div>

                <div class="property-net-list isbg" style="padding: 30px 0 30px;">
                    <div class="box-width">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="property-net-img slide-in-left" style="width: 100%;">
                                <img src="../../assets/pro/maternity-pc2.png" alt="">
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="slide-in-right">
                            <div class="title bigTop">门店管理后台</div>
                            <div class="details">专为企业门店业务管理打造的数字化管理平台，深度整合客户全生命周期管理、电子合同智能归档、个性化产康方案定制、标准化护理路径执行、智能营养膳食配餐、动态房态优化及精细化财务管理等核心业务模快，构建起“服务-数据-决策”的闭环管理体系。实现客户希求精准预测、服务质量实时监控、资源调度最优配置，并基于可视化数据看板为管理者提供多维度经营分析，从咨询签约到离店回访的每个环节都实现标准化、透明化、智能化管理。</div>
                            <div class="classify">
                                <el-row :gutter="20">
                                    <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item, index) in shopList" :key="index">
                                        <div class="classify-hover-pink">
                                            <img :src="item.icon" alt="" class="sway">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            </div>
                        </el-col>
                    </el-row> 
                    </div> 
                </div>

                <div class="property-net-list isbg3">
                    <div class="box-width">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="slide-in-left">
                            <div class="title bigTop">员工移动端</div>
                            <div class="details">
                                为团队打造专业高效的数字化工作平台，通过智能手机即可完成全流程服务管理。系统支持服务人员实时查看排班计划与任务清单，支持服务评价查询，帮助员工提升专业水平，助力销售的收款开单，满足多种支付场景。移动端与后台管理系统数据实时同步，确保服务过程全程可追溯。
                            </div>
                            <div class="classify">
                                <el-row :gutter="20">
                                    <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" v-for="(item, index) in staffList" :key="index">
                                        <div class="classify-hover-pink">
                                            <img :src="item.icon" alt="" class="sway">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            </div>
                        </el-col>
                        
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="property-net-img slide-in-right" style="width: 80%;">
                                <img src="../../assets/pro/maternity_mobile2.png" alt="">
                            </div>
                        </el-col>
                    </el-row>
                    </div>  
                </div>
                
            </div>
            </div>

            <div class="product_strength">
            <div class="property_strength charging_strength" style="padding: 40px 0 50px">
                <div class="box-width">
                    <div class="property_strength_title public_title">产品优势</div>
                    <el-row :gutter="25">
                        <div class="property_strength_box">
                            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(item,index) in strengthList" :key="index">
                                <div class="property_strength_box_list">
                                    <img :src="item.icon">
                                    <h4 class="pink">{{item.name}}</h4>
                                    <div class="property_strength_t">
                                        <span class="matrernity-strength-span" v-for="(st, i) in item.infoArr" :key="i+10086">
                                            <span class="disc">• </span>
                                            <span class="co">{{st}}</span>
                                        </span>
                                    </div>
                                </div>
                            </el-col>
                        </div>
                    </el-row>
                </div>
            </div>
            </div>

            
        </div>
      <footer-component></footer-component>
    </div>
</template>
<script>
export default {
    name: 'app_Matrernity',
    data () {
        return {
            mobileList: [
                {icon: require('../../assets/icon/maternity_icon1.png'), name: '预约点餐'},
                {icon: require('../../assets/icon/maternity_icon2.png'), name: '服务日程'},
                {icon: require('../../assets/icon/maternity_icon3.png'), name: '服务评价'},
                {icon: require('../../assets/icon/maternity_icon4.png'), name: '合同查询'},
                {icon: require('../../assets/icon/maternity_icon5.png'), name: '管家服务'}
            ],
            pcList: [
                {icon: require('../../assets/icon/maternity_icon6.png'), name: '权限管理'},
                {icon: require('../../assets/icon/maternity_icon7.png'), name: '门店配置'},
                {icon: require('../../assets/icon/maternity_icon8.png'), name: '财务管理'},
                {icon: require('../../assets/icon/maternity_icon9.png'), name: '客户档案'}
            ],
            shopList: [
                {icon: require('../../assets/icon/maternity_icon10.png'), name: '合同管理'},
                {icon: require('../../assets/icon/maternity_icon11.png'), name: '产康排期'},
                {icon: require('../../assets/icon/maternity_icon12.png'), name: '护理服务'},
                {icon: require('../../assets/icon/maternity_icon13.png'), name: '营养膳食'},
                {icon: require('../../assets/icon/maternity_icon14.png'), name: '房态日历'}
            ],
            staffList: [
                {icon: require('../../assets/icon/maternity_icon15.png'), name: '预约服务'},
                {icon: require('../../assets/icon/maternity_icon16.png'), name: '今日待办'},
                {icon: require('../../assets/icon/maternity_icon17.png'), name: '灵活收款'},
                {icon: require('../../assets/icon/maternity_icon18.png'), name: '消息提醒'},
            ],
            strengthList: [
                {icon: require('../../assets/icon/maternity_strength1.png'), name: '提升客资转换', 
                    infoArr: [
                        '标记客户标签和档案，形成客户画像；',
                        '同步跟进信息，协同推进客户签约合增值销售；',
                        '自动跟进提醒，及时关注跟进客户；',
                        '发送关怀短信和活动邀请，提升客户粘性；'
                    ]
                },
                {icon: require('../../assets/icon/maternity_strength2.png'), name: '灵活收费管理',
                    infoArr: [
                        '签约生成费用预算，按服务天数实现自动扣款；',
                        '财务管理业务审核，杜绝资金操作的风险；',
                        '自动统计员工服务工时和手工费用；',
                        '支持灵活分账，自动到账；'
                    ]
                },
                {icon: require('../../assets/icon/maternity_strength3.png'), name: '风险溯源管控', 
                    infoArr: [
                        '企业统一管理，门店服务规范标准化管理；',
                        '推送客户满意度调查，及时了解客户反馈，避免负面评价，影响品牌；',
                        '全流程溯源，客户签约后合同、每次服务的评价、护理记录都有迹可查；'
                    ]
                },
                {icon: require('../../assets/icon/maternity_strength4.png'), name: '企业定制化', 
                    infoArr: [
                        '支持对接第三方系统（OA、金蝶或其他业务系统）；',
                        '根据企业品牌定位和VI，定制化系统主题；',
                        '根据实际企业的管理流程和使用习惯，可对系统进行定制化调整，满足业务需求；'
                    ]
                }
            ],
        }
    }
}
</script>
<style lang="scss" scoped>
    .banner{background: url(../../assets/banner/baby1_bg.png) no-repeat 80% center;background-size: cover;height: 557px;
        &_box{width: 30%;padding-top: 5%;}
        &_title{color: #333;margin-bottom: 10px;}
        &_subTitle{color: #333;}
    }
    .property-net .isbg{background: #fff;}
    .property-net .isbg2{background: url(../../assets/banner/maternity2_bg.png)no-repeat center;background-size: cover;}
    .property-net .isbg3{background: url(../../assets/banner/maternity3_bg.png)no-repeat center;background-size: cover;}
    .charging_strength{background: #fff!important;}
    .mobile {
        .banner{
            &_box{width: 95%;}
            &_title{color: #fff;}
            &_subTitle{color: #fff;}
        }
        
    }
</style>